<template>
  <div v-html="content_section">
        <!-- section id="dlealp_section_services" class="feature_area p_120">
            <div class="container">
                <div class="main_title">
                    <h2>Por que somos &uacute;nicos</h2>
                    <p>Uma hist&oacute;ria escrita pelo empreendedorismo e inova&ccedil;&atilde;o</p>
                </div>
                <div class="row feature_inner">
                    <div class="col-lg-4 col-md-6">
                        <div class="feature_item">
                            <h4>Limpeza e manuten&ccedil;&atilde;o</h4>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-6">
                        <div class="feature_item">
                            <h4>P&oacute;s-vendas</h4>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-6">
                        <div class="feature_item">
                            <h4>Montagem e desmontagem</h4>
                        </div>
                    </div>
                    
                    <div class="col-lg-4 col-md-6">
                        <div class="feature_item">
                            <h4>Garantia</h4>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-6">
                        <div class="feature_item">
                            <h4>Log&iacute;stica</h4>
                        </div>
                    </div>
                </div>
            </div>
        </section -->
    </div>
</template>

<script>
export default {
    name: 'Services',
    props: {
      content_section: {},
    },
}
</script>

<style>

</style>